import _toConsumableArray from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import e from "fast-deep-equal";
import { useMemo as r } from "react";

function n(r, n, o) {
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

  var _iterator = _createForOfIteratorHelper(n),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;

      if (e(o, _r.args)) {
        if (i) return;
        if (_r.error) throw _r.error;
        if (_r.response) return _r.response;
        throw _r.promise;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var t = {
    args: o,
    promise: r.apply(void 0, _toConsumableArray(o)).then(function (e) {
      return t.response = e;
    }).catch(function (e) {
      return t.error = e;
    }).then(function () {
      s > 0 && setTimeout(function () {
        var e = n.indexOf(t);
        -1 !== e && n.splice(e, 1);
      }, s);
    })
  };
  if (n.push(t), !i) throw t.promise;
}

function o(r) {
  for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    n[_key - 1] = arguments[_key];
  }

  if (void 0 === n) r.splice(0, r.length);else {
    var _o = r.find(function (r) {
      return e(n, r.args);
    });

    if (_o) {
      var _e = r.indexOf(_o);

      -1 !== _e && r.splice(_e, 1);
    }
  }
}

function s(r) {
  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var i = [];
  return {
    read: function read() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }

      return n(r, i, e, s);
    },
    preload: function preload() {
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }

      n(r, i, e, s, !0);
    },
    clear: function clear() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }

      return o.apply(void 0, [i].concat(e));
    },
    peek: function peek() {
      for (var _len5 = arguments.length, r = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        r[_key5] = arguments[_key5];
      }

      var n;
      return null == (n = i.find(function (n) {
        return e(r, n.args);
      })) ? void 0 : n.response;
    }
  };
}

var i = [];

function t(e, o) {
  return r(function () {
    return n(e, i, o, t.lifespan);
  }, o);
}

t.lifespan = 0, t.clear = function () {
  for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    e[_key6] = arguments[_key6];
  }

  return o.apply(void 0, [i].concat(e));
}, t.preload = function (e) {
  for (var _len7 = arguments.length, r = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    r[_key7 - 1] = arguments[_key7];
  }

  n(e, i, r, t.lifespan, !0);
}, t.peek = function () {
  for (var _len8 = arguments.length, r = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    r[_key8] = arguments[_key8];
  }

  var n;
  return null == (n = i.find(function (n) {
    return e(r, n.args);
  })) ? void 0 : n.response;
};
export { s as createAsset, t as useAsset };